import ResultsNumber from './ResultsNumber';

export default ResultsNumber;
